export const partner = [
    {
        path: '/partners',
        name: '合伙人管理',
        component: () => import("@/views/layout/index.vue"),
        isDelete:false,
        children: [
            {
                path: 'details',
                component: () => import("@/views/sellerAdmin/partner/details/index.vue"),
                name: '合伙人详情',
                meta: {
                    hidden: true,
                    key: 12003,
                },
            },
            // {
            //   path: 'withdraw',
            //   component: () => import("@/views/sellerAdmin/withdraw/index.vue"),
            //   name: '提现详情',
            //   meta: {
            //       hidden: true,
            //       key: 12007,
            //   },
            // },
            {
              path: 'withdraw',
              component: () => import("@/views/sellerAdmin/withdraw/second/index.vue"),
              name: '商家配置',
              meta: {
                  hidden: true,
                  key: 12007,
              },
            },
            {
                path: 'release/:id?',
                component: () => import("@/views/sellerAdmin/marketing/wares/product-release/index.vue"),
                name: '商品发布',
                meta: {
                    hidden: true,
                    key: 12001,
                    path:'/partners/merchan-dising'
                },
            },
            {
                path: 'merchan-dising',
                component: () => import("@/views/sellerAdmin/marketing/wares/merchan-dising/index.vue"),
                name: '商品管理',
                meta: {
                    hidden: true,
                    key: 12002,
                    path:'/partners/release'
                },
            },
            {
                path: 'order',
                component: () => import("@/views/sellerAdmin/marketing/trade/order/index.vue"),
                name: '订单管理',
                meta: {
                    hidden: true,
                    key:12004,
                },
                redirect: 'order/list',
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/trade/order/default/index.vue"),
                        name: '订单列表',
                        meta: {
                            hidden: true,
                            key:12004,
                            isShow:false,
                            parent: '/partners/order'
                        },
                    },
                    {
                        path: 'delivery/:id',
                        component: () => import("@/views/sellerAdmin/marketing/trade/order/delivery/index.vue"),
                        name: '订单发货',
                        meta: {
                            hidden: true,
                            key:12004,
                            isShow:false,
                            parent: '/partners/order'
                        },
                    },
                    {
                        path: 'details/:id/:isEdit?',
                        component: () => import("@/views/sellerAdmin/marketing/trade/order/details/index.vue"),
                        name: '订单详情',
                        meta: {
                            hidden: true,
                            key:12004,
                            isShow:false,
                            parent: '/partners/order'
                        },
                    },

                ]
            },
            {
              path: 'purchase',
              component: () => import("@/views/sellerAdmin/supplier/purchase/index.vue"),
              name: '批采订货',
              meta: {
                  hidden: true,
                  key: 12005,
                  user:'partner'
              },
            },
            {
              path: 'purchase-order',
              component: () => import("@/views/sellerAdmin/supplier/purchase-order/index.vue"),
              name: '批采订单',
              meta: {
                  hidden: true,
                  key: 12006,
                  user:"partner"
              },
            },
            {
              path: 'purchase-details/:id',
              component: () => import("@/views/sellerAdmin/partner/purchase-details/index.vue"),
              name: '采购下单',
              isShow:false,
              meta: {
                  hidden: true,
                  key: 12005,
              },
            },
            {
                path: 'data-import',
                component: () => import("@/views/sellerAdmin/marketing/wares/data-import/index.vue"),
                name: '数据导入',
                meta: {
                    hidden: true,
                    key:12008,
                },
            },

        ]
    },

]
